import loadProductModule from './modules/Product.module';
const loadRelatedCategoriesModule = initialData => ({
    hasRouter: false,
    modules: [loadProductModule(initialData)],
});
export default loadRelatedCategoriesModule;
